export const HOOK_STORE_KEY = 'hook';
export const HOOK_SERVICE_KEY = 'hook';
export const HOOK_API_URL = '/api/v1/hook/';
